import { Tooltip } from '@/components/atoms/Tooltip';
import type { Business } from '@/modules/dashboard/dashboardTypes';
import { FlatStaff, InfoWhite } from '@/resources/assets/images';
import { useMemo } from 'react';

type StaffInfoSessionProps = Pick<Business, 'contactNames' | 'businessBureau'>;

export const StaffInfoSession = ({
	contactNames,
	businessBureau
}: StaffInfoSessionProps) => {
	const parsedContactTitle = useMemo(() => {
		if (!contactNames || contactNames.length === 0) return [];

		const valuesToRemove = ['contact name']; // Known values to remove

		return contactNames.map(contactInfo => {
			const titles = contactInfo.titles
				.filter(item => !valuesToRemove.includes(item.toLowerCase()))
				.map(
					item =>
						item.charAt(0).toUpperCase() +
						item.slice(1).toLowerCase()
				)
				.reverse();

			const name = contactInfo.name
				.toLowerCase()
				.replace(/\b\w/g, firstLetter => firstLetter.toUpperCase());

			return {
				title: `${name} ${
					titles.length >= 1 && `, ${titles.join(', ')}`
				}`.trim()
			};
		});
	}, [contactNames]);

	if (parsedContactTitle.length === 0) return null;

	return (
		<div className="flex w-full flex-col items-start gap-2 p-1">
			<header className="flex items-center gap-1 text-dm-mid-grey">
				<FlatStaff />

				<span className="inline-flex items-center gap-2">
					<p className="text-xs font-semibold md:text-base">
						Staff Info
					</p>

					<Tooltip.Provider>
						<Tooltip.Root>
							<Tooltip.Trigger>
								<InfoWhite />
							</Tooltip.Trigger>
							<Tooltip.Content className="text-sm text-dm-mid-grey">
								Information reported on most recent public
								corporate filings or estimated based on
								Resquared models otherwise.
							</Tooltip.Content>
						</Tooltip.Root>
					</Tooltip.Provider>
				</span>
			</header>

			{parsedContactTitle?.map(({ title }) => (
				<p
					className="text-sm font-semibold text-dm-white md:text-base"
					key={title}
				>
					{title}
				</p>
			))}

			{typeof businessBureau !== 'boolean' &&
				businessBureau?.businessManagersInfo?.map(contact => (
					<p
						className="text-sm font-semibold text-dm-white md:text-base"
						key={contact}
					>
						{contact}
					</p>
				))}
		</div>
	);
};
